import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { motion } from "framer-motion";
import { FiMail, FiLock, FiCheckCircle } from "react-icons/fi";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import Header from "../components/Header";
import Footer from "../components/Footer";
import config from "../config/config.json";
import Cookies from "js-cookie";

const Login = () => {
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm();

  const email = watch("email");
  const password = watch("password");

  const setUserData = (data) => {
    localStorage.setItem("userData", JSON.stringify(data));
  };

  const getUserData = async () => {
    try {
      setIsLoading(true);
      const { data } = await axios.get(
        "https://47g.utahdata.org/47gauthen/user/data",
        { withCredentials: true }
      );
      if (data.success) {
        setUserData(data.userData);
      }
    } catch (error) {
      //   toast.error(error.response?.data?.message || error.message);
      console.log("Error fetching user data:", error);
    }
  };

  const onSubmit = async ({ email, password }) => {
    console.log("coming onSubmit");

    setError(""); // Reset previous errors

    if (email === "david@bodex.io") {
      // 🔐 Try EXTERNAL login for David only
      try {
        const response = await axios.post(
          "https://47g.utahdata.org/47gauthen/auth/login",
          { email, password },
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            withCredentials: true,
          }
        );

        console.log("External login response:", response.data);

        if (response.data.success) {
          await getUserData(); // fetch user info if needed
          window.open("https://47g.utahdata.org/home", "_self");
          return;
        } else {
          setError("External login failed. Please check credentials.");
          return;
        }
      } catch (err) {
        console.error("External login failed:", err);
        setError("External login failed. Please try again later.");
        return;
      }
    } else {
      // 👥 Fallback for all other users
      try {
        console.log("====================================");
        console.log("request sent");
        console.log("====================================");
        const response = await axios.post(
          //config.APP_URL+"/c2j/ut-login",

          config.APP_URL + "/utahdata/login",
          { username: email, password },
          { withCredentials: true }
        );
        console.log("====================================");
        console.log(response);
        console.log("====================================");

        const { user, token } = response.data;

        if (user && token) {
          localStorage.setItem("user", JSON.stringify(user));
          localStorage.setItem("userDetails", JSON.stringify(user));
          localStorage.setItem("username", JSON.stringify(user.name));
          localStorage.setItem("token", token);

          navigate("/login-utahdata");
        } else {
          setError("Invalid login response from local server.");
        }
      } catch (err) {
        console.error("Local login failed:", err);
        setError("Invalid email or password.");
      }
    }
  };

  return (
    <>
      <Header />
      <section
        className="min-h-screen flex items-center justify-center bg-cover bg-center bg-no-repeat py-12"
        style={{
          backgroundImage: "url('/img/login.png')", // Replace with your own if needed
        }}
      >
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="bg-white/10 backdrop-blur-md border border-white/30 p-10 rounded-2xl shadow-lg w-full max-w-md"
        >
          <h2 className="text-2xl font-bold text-center text-gray-800 mb-6">
            Sign in to your account
          </h2>

          <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
            {/* Email Field */}
            <div className="relative">
              <label className="block text-sm font-medium text-gray-900 mb-1">
                Email Address
              </label>
              <FiMail className="absolute left-3 top-[52%] transform -translate-y-1/2 text-gray-400" />
              {email &&
                /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) &&
                !errors.email && (
                  <FiCheckCircle className="absolute right-3 top-[52%] transform -translate-y-1/2 text-green-500" />
                )}
              <input
                type="email"
                {...register("email", {
                  required: "Email is required",
                  pattern: {
                    value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                    message: "Invalid email format",
                  },
                })}
                placeholder="you@example.com"
                className={`pl-10 pr-10 w-full py-3 border rounded-lg focus:outline-none transition ${
                  errors.email
                    ? "border-red-500"
                    : email && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
                      ? "border-green-500"
                      : "border-gray-300 focus:border-blue-600 ring-1 ring-blue-100 focus:ring-blue-500"
                }`}
              />
              {errors.email && (
                <p className="text-red-500 text-sm mt-1">
                  {errors.email.message}
                </p>
              )}
            </div>

            {/* Password Field */}
            <div className="relative">
              <label className="block text-sm font-medium text-gray-900 mb-1">
                Password
              </label>
              <FiLock className="absolute left-3 top-[52%] transform -translate-y-1/2 text-gray-400" />
              {password?.length >= 5 && !errors.password && (
                <FiCheckCircle className="absolute right-3 top-[52%] transform -translate-y-1/2 text-green-500" />
              )}
              <input
                type="password"
                {...register("password", {
                  required: "Password is required",
                  minLength: {
                    value: 5,
                    message: "Password must be at least 5 characters",
                  },
                })}
                placeholder="Enter your password"
                className={`pl-10 pr-10 w-full py-3 border rounded-lg focus:outline-none transition ${
                  errors.password
                    ? "border-red-500"
                    : password?.length >= 5
                      ? "border-green-500"
                      : "border-gray-300 focus:border-blue-600 ring-1 ring-blue-100 focus:ring-blue-500"
                }`}
              />
              {errors.password && (
                <p className="text-red-500 text-sm mt-1">
                  {errors.password.message}
                </p>
              )}
            </div>

            {error && (
              <p className="text-red-600 text-sm font-medium text-center">
                {error}
              </p>
            )}

            <motion.button
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              type="submit"
              className="w-full bg-blue-600 text-white py-3 rounded-lg font-semibold hover:bg-blue-700 transition"
            >
              {isLoading ? "Signing in..." : "Sign In"}
            </motion.button>
            <p className="text-center font-bold">
              If not a user?{" "}
              <Link to="/register" className="font-bold">
                Sign Up
              </Link>
            </p>
          </form>
        </motion.div>
      </section>
      <Footer />
    </>
  );
};

export default Login;

// import React, { useState } from "react";
// import { useForm } from "react-hook-form";
// import { motion } from "framer-motion";
// import { FiMail, FiLock, FiCheckCircle } from "react-icons/fi";
// import { Link, useNavigate } from "react-router-dom";
// import axios from "axios";
// import Header from "../components/Header";
// import Footer from "../components/Footer";

// // import { toast } from "react-toastify";

// const Login = () => {
//   const navigate = useNavigate();

//   const users = [
//     { name: "Akash", email: "akash@bodex.io", password: "12345" },
//     { name: "Rajesh", email: "rajesh@bodex.io", password: "12345" },
//     { name: "Sumit", email: "sumit@bodex.io", password: "12345" },
//   ];

//   const [isLoading, setIsLoading] = useState(false);
//   const [error, setError] = useState("");

//   const {
//     register,
//     handleSubmit,
//     watch,
//     formState: { errors },
//   } = useForm();

//   const email = watch("email");
//   const password = watch("password");

//   const setUserData = (data) => {
//     localStorage.setItem("userData", JSON.stringify(data));
//   };

//   const getUserData = async () => {
//     try {
//       setIsLoading(true);
//       const { data } = await axios.get(
//         "https://47g.utahdata.org/47gauthen/user/data",
//         { withCredentials: true }
//       );
//       if (data.success) {
//         setUserData(data.userData);
//       }
//     } catch (error) {
//       //   toast.error(error.response?.data?.message || error.message);
//       console.log("Error fetching user data:", error);
//     }
//   };

//   const onSubmit = async ({ e, email, password }) => {
//     // e.preventDefault();
//     setError("");
//     try {
//       const response = await axios.post(
//         "https://47g.utahdata.org/47gauthen/auth/login",
//         { email, password },
//         {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//             Accept: "application/json",
//           },
//           withCredentials: true,
//         }
//       );
//       console.log("Login response:", response.data);
//       if (response.data.success) {
//         await getUserData();
//         window.open("https://47g.utahdata.org/home", "_self");
//         return;
//       }
//     } catch (err) {
//       console.warn("External login failed, checking local fallback...");
//     }

//     const user = users.find(
//       (u) => u.email === email && u.password === password
//     );
//     if (user) {
//       localStorage.setItem("user", JSON.stringify(user));
//       navigate("/login/dashboard", { state: { name: user.name } });
//     } else {
//       setError("Invalid email or password");
//     }
//   };

//   return (
//     <>
//     <Header/>
//     <section
//       className="min-h-screen flex items-center justify-center bg-cover bg-center bg-no-repeat py-12"
//       style={{
//         backgroundImage: "url('/img/login.png')", // Replace with your own if needed
//       }}
//     >
//     {/* <Link to={"/"}>
//       <header className="fixed top-0 left-0 w-full header z-20">
//         <img
//           src="/img/headerlogo.png"
//           alt="Utah Data Logo"
//           className="logo"
//         />
//       </header>
//       </Link> */}

//       <motion.div
//         initial={{ opacity: 0, y: 40 }}
//         animate={{ opacity: 1, y: 0 }}
//         transition={{ duration: 0.6 }}
//         className="bg-white/10 backdrop-blur-md border border-white/30 p-10 rounded-2xl shadow-lg w-full max-w-md"
//       >
//         <h2 className="text-2xl font-bold text-center text-gray-800 mb-6">
//           Sign in to your account
//         </h2>

//         <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
//           {/* Email Field */}
//           <div className="relative">
//             <label className="block text-sm font-medium text-gray-900 mb-1">
//               Email Address
//             </label>
//             <FiMail className="absolute left-3 top-[52%] transform -translate-y-1/2 text-gray-400" />
//             {email &&
//               /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) &&
//               !errors.email && (
//                 <FiCheckCircle className="absolute right-3 top-[52%] transform -translate-y-1/2 text-green-500" />
//               )}
//             <input
//               type="email"
//               {...register("email", {
//                 required: "Email is required",
//                 pattern: {
//                   value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
//                   message: "Invalid email format",
//                 },
//               })}
//               placeholder="you@example.com"
//               className={`pl-10 pr-10 w-full py-3 border rounded-lg focus:outline-none transition ${
//                 errors.email
//                   ? "border-red-500"
//                   : email && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
//                     ? "border-green-500"
//                     : "border-gray-300 focus:border-blue-600 ring-1 ring-blue-100 focus:ring-blue-500"
//               }`}
//             />
//             {errors.email && (
//               <p className="text-red-500 text-sm mt-1">
//                 {errors.email.message}
//               </p>
//             )}
//           </div>

//           {/* Password Field */}
//           <div className="relative">
//             <label className="block text-sm font-medium text-gray-900 mb-1">
//               Password
//             </label>
//             <FiLock className="absolute left-3 top-[52%] transform -translate-y-1/2 text-gray-400" />
//             {password?.length >= 5 && !errors.password && (
//               <FiCheckCircle className="absolute right-3 top-[52%] transform -translate-y-1/2 text-green-500" />
//             )}
//             <input
//               type="password"
//               {...register("password", {
//                 required: "Password is required",
//                 minLength: {
//                   value: 5,
//                   message: "Password must be at least 5 characters",
//                 },
//               })}
//               placeholder="Enter your password"
//               className={`pl-10 pr-10 w-full py-3 border rounded-lg focus:outline-none transition ${
//                 errors.password
//                   ? "border-red-500"
//                   : password?.length >= 5
//                     ? "border-green-500"
//                     : "border-gray-300 focus:border-blue-600 ring-1 ring-blue-100 focus:ring-blue-500"
//               }`}
//             />
//             {errors.password && (
//               <p className="text-red-500 text-sm mt-1">
//                 {errors.password.message}
//               </p>
//             )}
//           </div>

//           {error && (
//             <p className="text-red-600 text-sm font-medium text-center">
//               {error}
//             </p>
//           )}

//           <motion.button
//             whileHover={{ scale: 1.02 }}
//             whileTap={{ scale: 0.98 }}
//             type="submit"
//             className="w-full bg-blue-600 text-white py-3 rounded-lg font-semibold hover:bg-blue-700 transition"
//           >
//             {isLoading ? "Signing in..." : "Sign In"}
//           </motion.button>
//         </form>
//       </motion.div>
//     </section>
//     <Footer/>
//     </>
//   );
// };

// export default Login;
